import apiClient from '../api/axios';

// Story 25 — triggers a real file download from the payroll muster export endpoint's blob
// response, mirroring downloadScheduleCsv.js. `from`/`to` are YYYY-MM-DD strings.
export async function downloadMusterCsv(from, to) {
  const res = await apiClient.get('/api/reports/muster.csv', {
    params: { from, to },
    responseType: 'blob',
  });

  const disposition = res.headers?.['content-disposition'] || '';
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i);
  const filename = utf8Match
    ? decodeURIComponent(utf8Match[1])
    : plainMatch
      ? plainMatch[1]
      : `bentoping-muster-${from}_${to}.csv`;

  const url = window.URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
